import * as React from "react";
import {useState} from "react";
import {environment} from "src/environments/environment";
import {Button, CircularProgress, Dialog, DialogActions, Grid, Typography} from "@material-ui/core";
import {createStyles, makeStyles, Theme} from '@material-ui/core/styles';
import {deleteButtonColor, textColor} from '../../sub-components/colors/colors';
import {AlertBar} from "src/components/sub-components/AlertBar";

export function DeleteUserRole(props) {
  const classes = useStyles()
  const [alertOpen, setAlertOpen] = useState(false)
  const [severity, setSeverity] = useState("success")
  const [topic, setTopic] = useState("")
  const [message, setMessage] = useState("")

  //loading State
  const [loading,setLoading] = useState(false)

  const deleteRole = (id) => {
    // setLoading(true)
    fetch(`${environment.host}/ums/super/user-role/${id}`,
      {
        method: "DELETE",
        headers: {'Content-Type': 'application/json',Authorization: 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')}
      }).then(response => response.json())
      .then(data => {
        if (data.message === "Success") {
          setLoading(false)
          
          props.getUserRoles()
          props.setAlertOpen(true)
          props.setSeverity("success")
          props.setTopic("Success")
          props.setMessage("User role deleted successfully")
          props.onClose()
          setTimeout(() => {
            props.setAlertOpen(false)
          }, 4000)
        } else {
          setLoading(false)
          props.setAlertOpen(true)
          props.setSeverity("error")
          props.setTopic("Error")
          props.setMessage(data.message)
          props.onClose()
          setTimeout(() => {
            setAlertOpen(false)
          }, 6000)
        }
      })
  }

  const openDeletePopup = (id, name) => {
    setLoading(true)
    fetch(environment.host + '/ums/user/' + props.getUserId() + '/system-user?filter=none', {
      method: "GET",
      headers: {'Content-Type': 'application/json',Authorization: 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')}

    }).then(res => res.json()
    ).then(data => {
      const filterUser = data.content.filter((user) => {
        return user.userRoleId === id
      })
      if (filterUser.length !== 0) {
        setLoading(false)
        props.setAlertOpen(true)
        props.setSeverity("error")
        props.setTopic("Error")
        props.setMessage(name + " role is already assigned to some users & Delete those users prior to delete this role")
        props.onClose()
        setTimeout(() => {
          props.setAlertOpen(false)
        }, 6000)
      } else {
        deleteRole(id)
      }
    })

  }


  return (
    <div>
      <Dialog open={props.open} maxWidth="md">
        <Grid item xs={12} md={12} style={{padding: '20px'}}>
          <Typography>Do you really want to delete the user role {props.userName}?</Typography>
        </Grid>
        {
          <DialogActions style={{width: "100%", justifyContent: 'right', marginTop: '10px'}} hidden>
            <Button variant='contained' className={classes.cancel} onClick={() => props.onClose()}>
              Cancel
            </Button>
            <Button variant='contained' className={classes.delete} onClick={() => openDeletePopup(props.id,props.userName)}>
              Delete
            </Button>
          </DialogActions>
        }
      </Dialog>

      <AlertBar open={alertOpen} severity={severity} topic={topic} message={message}/>
      {loading &&
        <div style={{
          position: 'fixed',
          left: 0,
          top: 0,
          backgroundColor: '#000000',
          opacity: 0.5,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 9999,
          width: '100vw',
          height: '100vh'
        }}>
          <CircularProgress size={80}/>
        </div>
      }
    </div>
  )

}

const useStyles = makeStyles((themes: Theme) =>
  createStyles({
    delete: {
      backgroundColor: deleteButtonColor,
      color: "white",
      marginBottom: "10px",
      marginRight: "10px",
      width: "20%",
      boxShadow: "none",
      "&:hover": {
        boxShadow: "none",
      }
    },
    cancel: {
      backgroundColor: "white",
      color: textColor,
      marginBottom: "10px",
      marginRight: "10px",
      width: "20%",
      boxShadow: "none",
      "&:hover": {
        boxShadow: "none",
      }
    }
  }),
);
